import { render } from "./Notice.m.backup.vue?vue&type=template&id=e81ca0bc&scoped=true"
import script from "./Notice.m.backup.vue?vue&type=script&lang=js"
export * from "./Notice.m.backup.vue?vue&type=script&lang=js"

import "./Notice.m.backup.vue?vue&type=style&index=0&id=e81ca0bc&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81ca0bc"]])

export default __exports__